<template>
  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{message.attributes['label']}}</td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 ">
    <ActiveWidget :active="message.attributes['active']" :readOnly="true" />
  </td>
  <td class="px-3 py-4 text-sm text-gray-500 sm:max-w-xs lg:max-w-lg truncate">
    {{message.attributes['text']}}
  </td>
  <td class="px-3 py-4 text-sm text-gray-500 sm:max-w-xs lg:max-w-lg truncate">
    <div class=" max-h-40 max-w-sm" v-if="message.attributes['media-type'] === 'image'">
      <ImageView :url="message.attributes['media-uri']" />
    </div>
    <div v-if="message.attributes['media-type'] === 'video'">
       <video width="320" height="240" controls>
          <source v-bind:src="message.attributes['media-uri']" type="video/mp4">
       </video>
    </div>
    <div v-if="message.attributes['media-type'] === 'file'">
       <a v-bind:href="message.attributes['media-uri']" target="_blank" class="font-bold">{{ $t('conversation.downloadAttachment') }}</a>
    </div>
  </td>
  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
    <button v-on:click="openEdit" type="button" class="mr-3 inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
      <PencilIcon class="-ml-0.5 mr-2 h-4 w-4" />
      {{ $t('actions.edit') }}
    </button>
    <button v-on:click="askRemove" type="button" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
      <TrashIcon class="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
      {{ $t('actions.remove') }}
    </button>
    <CannedDelete v-if="showRemove" v-bind:message="message" v-on:delete-finished-event="removeMessage" />
    <CannedEdit v-if="showEdit" v-bind:message="message" v-on:update-finished-event="editEnded" />
  </td>
</template>


<script>
import { TrashIcon } from '@heroicons/vue/outline'
import { PencilIcon } from '@heroicons/vue/solid';
import ImageView from '@/components/conversations/parts/ImageView.vue'

import ActiveWidget from '../automations/ActiveWidget'
import CannedDelete from './CannedDelete'
import CannedEdit from './CannedEdit'

export default {
  name: 'CannedListItem',
  props: ['message'],
  emits: ['delete-event', 'edit-event'],
  components: {
    ActiveWidget,
    CannedDelete,
    CannedEdit,
    ImageView,
    //
    TrashIcon,
    PencilIcon,
  },
  methods: {
    askRemove() {
      this.showRemove = true;
    },
    removeMessage() {
      this.showRemove = false;
      this.$emit('delete-event');
    },
    openEdit() {
      this.showEdit = true;
    },
    editEnded() {
      this.showEdit = false;
      this.$emit('edit-event');
    }
  },
  data() {
    return {
      showRemove: false,
      showEdit: false,
    }
  },
}
</script>
